const childrenLoaded = require('@alexspirgel/children-loaded');
import AccordionJs from 'accordion-js';

class Accordion extends HTMLElement {

    constructor() {
        super();
    }

    async connectedCallback() {
        // Moving the section in the DOM runs connectedCallback again. A second AccordionJs
        // instance would toggle each panel twice per click, so bind only once.
        if (this.accordionBound) return;
        this.accordionBound = true;
        await childrenLoaded(this);
        const accordionContainer = this.querySelector('.acf-innerblocks-container');
        new AccordionJs(accordionContainer, {});

        // iOS WebKit clips the last line of expanded panels because accordion-js's
        // transitionend → height:auto handoff is unreliable on iOS. Force the
        // handoff after the lib's default 600ms transition + buffer.
        accordionContainer.addEventListener('click', (event) => {
            if (!event.target.closest('.ac-trigger')) return;
            setTimeout(() => {
                accordionContainer.querySelectorAll('.ac.is-active > .ac-panel').forEach((panel) => {
                    if (panel.style.height && panel.style.height !== 'auto') {
                        panel.style.height = 'auto';
                    }
                });
            }, 700);
        });
    }

}

customElements.define('x-accordion', Accordion, {extends: 'section'});